import React from 'react';
import { FormCheckbox } from 'shards-react';
import type { ICellRendererParams } from 'ag-grid-community';

const BooleanRenderer = (params: ICellRendererParams) => {
  const checked: boolean = params.getValue() ? true : false;
  // console.log(params.getValue());

  /**
   * 確認用
   */
  // useEffect(() => {
  // }, []);

  return (
    <>
      <div className="text-center">
        <FormCheckbox className="" size="sm" inline checked={checked} />
      </div>
    </>
  );
};

export default BooleanRenderer;
